import styled from "styled-components";
import { colors, text } from "~/assets/js/theme/constants";

const padding = 12;

export const ListItemContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    :not(:last-child) {
        border-bottom: 1px solid ${colors.LAYOUT.GRAY[200]};
    }
    padding: ${padding}px;
    background-color: #ffffff;
    &.linked {
        cursor: pointer;
        transition: 300ms;
        img {
            filter: brightness(0);
        }
        :hover {
            background-color: ${colors.BRAND.PRIMARY[100]};
            border-radius: 8px;
        }
    }
`;

export const Left = styled.div``;

export const Center = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: center;
    margin-right: ${padding}px;
    margin-left: ${padding}px;
`;

export const Content = styled.div`
    font-weight: ${text.BOLD.WEIGHT};
    font-family: ${text.BOLD.FONT};
    font-size: 16px;
    line-height: 19px;
    color: ${colors.LAYOUT.GRAY[1000]};

    [data-name] {
        font-weight: ${text.BOLD.WEIGHT};
        font-family: ${text.BOLD.FONT};
        font-size: 16px;
        line-height: 19px;
        color: ${colors.LAYOUT.GRAY[1000]};
    }
`;

export const Details = styled.div`
    font-weight: ${text.REGULAR.WEIGHT};
    font-family: ${text.REGULAR.FONT};
    font-size: 14px;
    line-height: 20px;
`;

export const Right = styled.div`
    font-weight: ${text.REGULAR.WEIGHT};
    font-family: ${text.REGULAR.FONT};
    font-size: 16px;
    color: ${colors.LAYOUT.GRAY[700]};
`;
